<app-audit-logs-table
  [initialQuery]="initialQuery()"
  [tableColumnsDef]="auditTableDef()"
/>
